export enum Cy_Opravneni {
  // Taby
  specifikaceOpravneniTab = 'specifikace-opravneni-tab',
  zastupovanyTab = 'zastupovany-tab',
  zastupujiciTab = 'zastupujici-tab',
  duvodVyhledavaniOpravneniTab = 'duvod-vyhledavani-opravneni-tab',

  // Specifikace opravneni
  kodOpravneni = 'kod-opravneni',
  kodSablony = 'kod-sablony',
  platnostOd = 'platnost-od',
  platnostDo = 'platnost-do',
  status = 'status',
  datumZmeny = 'datum-zmeny',
  vytvoreno = 'vytvoreno',
  kodOvm = 'kod-ovm',
  nazevOvm = 'nazev-ovm',

  // Zastupovaný FO
  zastupovanySelectFO = 'zastupovany-fyzicka-osoba-option',
  zastupovanyJmeno = 'zastupovany-jmeno',
  zastupovanyPrijmeni = 'zastupovany-prijmeni',
  zastupovanyDatumNarozeni = 'zastupovany-datum-narozeni',
  zastupovanyDruhDokladu = 'zastupovany-druh-dokladu',
  zastupovanyCisloDokladu = 'zastupovany-cislo-dokladu',

  // Zastupující FO
  zastupujiciSelectFO = 'zastupujici-fyzicka-osoba-option',
  zastupujiciJmeno = 'zastupujici-jmeno',
  zastupujiciPrijmeni = 'zastupujici-prijmeni',
  zastupujiciDatumNarozeni = 'zastupujici-datum-narozeni',
  zastupujiciDruhDokladu = 'zastupujici-druh-dokladu',
  zastupujiciCisloDokladu = 'zastupujici-cislo-dokladu',

  // Zastupovaná PO
  zastupovanySelectPO = 'zastupovany-pravnicka-osoba-option',
  // zastupovanyNazev = 'zastupovany-nazev', DIAREZA-1881
  zastupovanyICO = 'zastupovany-ico',

  // Zastupující PO
  zastupujiciSelectPO = 'zastupujici-pravnicka-osoba-option',
  // zastupujiciNazev = 'zastupujici-nazev', DIAREZA-1881
  zastupujiciICO = 'zastupujici-ico',

  // Důvod vyhledávání
  duvodUcel = 'duvod-ucel',

  // Tlačítka
  search = 'opravneni-search-button',
  clear = 'opravneni-clear-filter-button',

  // Ostatní
  title = 'opravneni-title',
  table = 'opravneni-table',
  form = 'opravneni-form',
  actionButton = 'opravneni-action-button',

  // Tooltipy
  tooltipZastupovany = 'tooltip-zastupovany',
  tooltipZastupujici = 'tooltip-zastupujici',

  /**
   * Detail
   */
  // Taby
  detailTab = 'detail-tab',
  historieTab = 'historie-tab',

  downloadPdf = 'download-pdf',

  specifikaceTable = 'specifikace-table',
  zastupTable = 'zastup-table',

  // Zneplatneni flow (route :idOrKod/zneplatneni)
  zneplatnitButton = 'opravneni-zneplatnit-button',
  zneplatnitConfirmAccept = 'opravneni-zneplatnit-confirm-accept',
  zneplatnitConfirmReject = 'opravneni-zneplatnit-confirm-reject',
}

// readonly Cy_Opravneni = Cy_Opravneni;
// [attr.data-cy]="Cy_Opravneni.title"
